// extracted by mini-css-extract-plugin
module.exports = {"withLoader":"Loader_withLoader__33EhC","loader":"Loader_loader__3rnyC","lds-dual-ring":"Loader_lds-dual-ring__uIJ6j"};